import React from 'react';

import config from 'config';

const Feedback: React.FC = () => {
  return (
    <a href={config.peopleFeedbackUrl} target="_blank" rel="noopener noreferrer" className="footer__label">
      Give Feedback
    </a>
  );
};

export default Feedback;
